import {Container, Nav, Tab} from "react-bootstrap";
import {useCallback, useEffect} from "react";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import * as React from "react";
import {Balances} from "./Balances";
import {Orders} from "./Orders";
import {Config} from "./Config";
import {Api} from "../../_api";

export const Account = ({account, exchange, exchangeState, onConfigSubmit, configFields, showConfig, deleteAccount, orderFns}) => {
    const location = useLocation()
    const navigate = useNavigate()
    const activeAction = location.pathname.split("/")[5];
    const api = Api.forExchange(exchange).forAccount(account)

    const buildUrl = useCallback(action => `/exchange/${exchange}/accounts/${account}/${action}`, [account, exchange])

    const onTabChange = newValue => navigate(buildUrl(newValue))

    useEffect(() => {
        if (typeof activeAction === 'undefined') {
            navigate(buildUrl(showConfig ? 'config' : 'orders'))
        }
    }, [activeAction, buildUrl, navigate, showConfig])

    return <Container fluid className={"mt-3"}>
        <Tab.Container id={`exchange-${account}`} onSelect={onTabChange}
                       defaultActiveKey={activeAction} activeKey={activeAction}>
            <Nav variant="pills">
                {showConfig || <Nav.Item>
                    <Nav.Link eventKey={"orders"}>{"Orders"}</Nav.Link>
                </Nav.Item>}
                {showConfig || <Nav.Item>
                    <Nav.Link eventKey={"balance"}>{"Balances"}</Nav.Link>
                </Nav.Item>}
                <Nav.Item className={showConfig ? "hidden" : ""}>
                    <Nav.Link eventKey={"config"}>{"Config"}</Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                <Routes>
                    <Route path={"/orders"} element={<Tab.Pane eventKey={"orders"}>
                        <Orders exchange={exchange} account={account} orderFns={orderFns}/>
                    </Tab.Pane>}/>
                    <Route path={"/balance"} element={<Tab.Pane eventKey={"balance"}>
                        <Balances account={account} api={api}/>
                    </Tab.Pane>}/>
                    <Route path={"/config"} element={<Tab.Pane eventKey={"config"}>
                        <Config account={account}
                                exchangeState={exchangeState} deleteAccount={deleteAccount}
                                onConfigSubmit={onConfigSubmit} configFields={configFields}/>
                    </Tab.Pane>}/>
                </Routes>
            </Tab.Content>
        </Tab.Container>
    </Container>
}
